export default __webpack_public_path__ + "static/media/Ramp_8x8x4.256.8e9a2639.png";